<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex align-items-center user-member__title">
                            <h4 class="text-capitalize fw-500 breadcrumb-title">
                                Monitor Domain &amp; Subdomain
                            </h4>
                        </div>
                        <div class="action-btn">
                            <button @click="load" class="btn btn-secondary mr-2" :disabled="loading">
                                <i class="fas fa-sync-alt"></i> Refresh
                            </button>
                            <button @click="showForm = !showForm" class="btn btn-primary">
                                <i class="fas fa-plus"></i> Tambah URL
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="showForm" class="card p-4 mb-3">
                <h5 class="mb-3">Tambah domain / subdomain</h5>
                <div class="row">
                    <div class="col-md-4 mb-2">
                        <label>Label</label>
                        <input v-model="form.label" class="form-control" placeholder="api.starsender.online">
                    </div>
                    <div class="col-md-5 mb-2">
                        <label>URL</label>
                        <input v-model="form.url" class="form-control" placeholder="https://api.starsender.online/">
                    </div>
                    <div class="col-md-3 mb-2">
                        <label>Jenis</label>
                        <select v-model="form.kind" class="form-control">
                            <option value="domain">Domain</option>
                            <option value="subdomain">Subdomain</option>
                        </select>
                    </div>
                </div>
                <button @click="create" class="btn btn-success mt-2" :disabled="saving">
                    Simpan
                </button>
            </div>

            <div class="alert alert-info">
                Notifikasi <strong>offline / online</strong> dikirim ke bot Telegram admin (menu Telegram Bot Setup).
                Pengecekan otomatis setiap ~5 menit. Node server WA memakai monitor terpisah (Node Server Monitor).
            </div>

            <div class="row mb-3">
                <div class="col-md-4">
                    <div class="card p-3 text-center">
                        <small class="text-muted">Monitor service</small>
                        <h4 :class="monitorRunning ? 'text-success' : 'text-danger'">
                            {{ monitorRunning ? 'Active' : 'Inactive' }}
                        </h4>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card p-3 text-center">
                        <small class="text-muted">Online</small>
                        <h4 class="text-success">{{ onlineCount }}</h4>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card p-3 text-center">
                        <small class="text-muted">Offline</small>
                        <h4 class="text-danger">{{ offlineCount }}</h4>
                    </div>
                </div>
            </div>

            <div class="card p-3">
                <div class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th>Label</th>
                                <th>URL</th>
                                <th>Jenis</th>
                                <th>Status</th>
                                <th>HTTP</th>
                                <th>RT (ms)</th>
                                <th>Aktif</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="ep in endpoints" :key="ep.id">
                                <td>{{ ep.label }}</td>
                                <td><code>{{ ep.url }}</code></td>
                                <td>{{ ep.kind }}</td>
                                <td>
                                    <span v-if="ep.status === 'online'" class="badge badge-success">Online</span>
                                    <span v-else-if="ep.status === 'offline'" class="badge badge-danger">Offline</span>
                                    <span v-else class="badge badge-secondary">{{ ep.status || 'unknown' }}</span>
                                </td>
                                <td>{{ ep.last_http_code || '-' }}</td>
                                <td>{{ ep.response_time || '-' }}</td>
                                <td>
                                    <input type="checkbox" :checked="ep.enabled" @change="toggleEnabled(ep)">
                                </td>
                                <td>
                                    <button class="btn btn-sm btn-outline-danger" @click="remove(ep)">Hapus</button>
                                </td>
                            </tr>
                            <tr v-if="!loading && endpoints.length === 0">
                                <td colspan="8" class="text-center text-muted">Belum ada URL — tambahkan domain StarSender di atas.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            loading: false,
            saving: false,
            showForm: false,
            endpoints: [],
            monitorRunning: false,
            form: {
                label: '',
                url: '',
                kind: 'subdomain',
            },
        };
    },
    computed: {
        onlineCount() {
            return this.endpoints.filter(e => e.status === 'online').length;
        },
        offlineCount() {
            return this.endpoints.filter(e => e.status === 'offline').length;
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.loading = true;
            try {
                const res = await axios.get('/api/v1/admin/monitored-endpoints');
                if (res.data.success) {
                    this.endpoints = res.data.data.endpoints || [];
                    this.monitorRunning = !!res.data.data.monitor_running;
                }
            } finally {
                this.loading = false;
            }
        },
        async create() {
            this.saving = true;
            try {
                const res = await axios.post('/api/v1/admin/monitored-endpoint', {
                    label: this.form.label,
                    url: this.form.url,
                    kind: this.form.kind,
                    enabled: true,
                });
                if (res.data.success) {
                    this.form = { label: '', url: '', kind: 'subdomain' };
                    this.showForm = false;
                    await this.load();
                } else {
                    alert(res.data.message || 'Gagal menyimpan');
                }
            } catch (e) {
                alert(e.response?.data?.message || 'Gagal menyimpan');
            } finally {
                this.saving = false;
            }
        },
        async toggleEnabled(ep) {
            try {
                await axios.put(`/api/v1/admin/monitored-endpoint/${ep.id}`, {
                    enabled: !ep.enabled,
                });
                await this.load();
            } catch (e) {
                alert(e.response?.data?.message || 'Gagal update');
            }
        },
        async remove(ep) {
            if (!confirm(`Hapus monitor untuk ${ep.url}?`)) return;
            try {
                await axios.delete(`/api/v1/admin/monitored-endpoint/${ep.id}`);
                await this.load();
            } catch (e) {
                alert(e.response?.data?.message || 'Gagal hapus');
            }
        },
    },
};
</script>
